import { render } from "./CommunitySale.vue?vue&type=template&id=227724e0&scoped=true"
import script from "./CommunitySale.vue?vue&type=script&lang=js"
export * from "./CommunitySale.vue?vue&type=script&lang=js"

import "./CommunitySale.vue?vue&type=style&index=0&id=227724e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227724e0"]])

export default __exports__